import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import { changeSelectedEpisodeEvents } from '../../store/episodes/episodes.slice';
import { changeEventDisplayVisible } from '../../store/ui/ui.slice';

import formatNumber from '../../utilities/formatNumber';

export default function ZoneItemName({
  name,
  amount = null,
  events = [],
  isMoney,
  date = '',
  extra=undefined
}) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(changeSelectedEpisodeEvents({ events, date }));
    dispatch(changeEventDisplayVisible(true));
  };

  if (isMoney) {
    amount =
      '$' + (isNaN(amount) || amount === null ? '-' : formatNumber(amount));
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'end' }}>
      <div
        className={
          'item-name-flex' + (name === 'Total' ? ' item-name-total' : '')
        }
        style={{ width: '100%' }}
      >
        {name === 'Total' ? (
          <div className='item-name'>Total:</div>
        ) : (
          <div>
            Zone -&nbsp;
            {name ? name : 'State-wide'}
            {amount !== null ? ':' : ''}
          </div>
        )}
        <div className='item-name-amount'><div>{amount}</div></div>
      </div>

      {extra && extra.map((countyName, i) => 
        <div
          key={i}
          className={
            'item-name-flex' + (name === 'Total' ? ' item-name-total' : '')
          }
          style={{ width: '100%' }}
        >
          <div onClick={handleClick} className='item-name-clickable' style={{ paddingLeft: '10px' }}>{countyName}</div>
          <div className='item-name-amount' />
        </div>
      )}
    </div>
  );
}

ZoneItemName.propTypes = {
  name: PropTypes.string,
  amount: PropTypes.number,
  events: PropTypes.array,
  isMoney: PropTypes.bool,
  date: PropTypes.string,
  extra: PropTypes.array
};
